module.exports = __webpack_public_path__ + "img/pla_YYC.2598a052.png";